import Cookie from './Cookie';

export default class CookieBar {

    constructor() {
        this.bar = document.querySelector('[data-cookie-bar]');
        this.close_btn = document.querySelector('[data-cookie-bar]');
        this.cookie = null;
        this.cookie_name = 'pp-cookie';
        this.cookie_exists = false;
    }

    init() {
        if (!this.bar || !this.close_btn) {
            return false;
        }

        this.cookie = new Cookie(this.cookie_name, 'accepted', 30)
        this.checkCookieExist();

        if (this.cookie_exists) {
            this.bar.style.display = 'none';
            return true;
        } else {
            // this.showCookieBar();
            this.setListener();
            // this.autoAccept();
        }
    }

    // showCookieBar() {
    //   this.bar.style.cssText = 'transform: translateY(0); z-index: 9999';
    // }

    checkCookieExist() {
        this.cookie_exists = this.cookie.checkCookieExist(this.cookie_name);
    }

    acceptCookie() {
        this.cookie.createCookie();
        this.hideCookieBar();
    }

    hideCookieBar() {
        this.bar.style.transform = 'translateY(120%)';
    }

    setListener() {
        this.close_btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.acceptCookie();
        });
    }

    // autoAccept() {
    //     setTimeout(() => {
    //       this.acceptCookie();
    //     }, 20000)
    // }

}
